// @flow
import React, {useEffect} from 'react';
import {observer} from "mobx-react-lite";
import rootStore from "../stores";

const AuthWrapper = observer(
    ({role, children}: {role: string, children: any}) => {
    const sessionStore = rootStore.sessionStore;

    useEffect(() => {
            sessionStore.setRequiredRole(role);
            return () => sessionStore.setRequiredRole("user");
        },
        [role]);

    if (sessionStore.hasRole(role)) return children;
    return (<div/>);
});

export default AuthWrapper;
